import type { ReactNode } from "react";
import { cx } from "../cx";
import styles from "./Switch.module.css";

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  /** Accessible name when there is no visible label (settings rows label the switch from their title). */
  "aria-label"?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
}

export function Switch({ checked, onChange, label, disabled, id, className, ...rest }: SwitchProps) {
  return (
    <label className={cx(styles.root, disabled && styles.disabled, className)}>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={rest["aria-label"]}
        disabled={disabled}
        className={cx(styles.track, checked && styles.checked)}
        onClick={() => onChange(!checked)}
      >
        <span className={styles.thumb} />
      </button>
      {label !== undefined && <span>{label}</span>}
    </label>
  );
}
